const rankings = [
  { rank: 1, title: '暗夜追踪 第二季', heat: '985万', trend: 'up', category: '悬疑犯罪' },
  { rank: 2, title: '长安秘史', heat: '872万', trend: 'up', category: '古装权谋' },
  { rank: 3, title: '星际迷航：新纪元', heat: '756万', trend: 'up', category: '科幻史诗' },
  { rank: 4, title: '深海冒险', heat: '698万', trend: 'down', category: '韩剧爱情' },
  { rank: 5, title: '异世界勇者', heat: '623万', trend: 'up', category: '奇幻动漫' },
  { rank: 6, title: '极限挑战 第十季', heat: '587万', trend: 'up', category: '户外综艺' },
  { rank: 7, title: '春风十里不如你', heat: '541万', trend: 'down', category: '都市情感' },
];

export default function RankingSection() {
  return (
    <section
      id="ranking"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50 scroll-mt-16"
    >
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center">
          热播排行
        </h2>
        <div className="mt-2 w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>

        <div className="mt-10 flex flex-col gap-2">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 px-4 py-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold whitespace-nowrap ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 truncate">{item.title}</h3>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>

              <div className="flex items-center gap-1 text-sm font-semibold text-primary-500">
                <i
                  className={`text-xs ${
                    item.trend === 'up' ? 'ri-arrow-up-line text-accent-500' : 'ri-arrow-down-line text-foreground-500'
                  }`}
                ></i>
                <span className="whitespace-nowrap">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}